import { render, staticRenderFns } from "./LevelTwoList.vue?vue&type=template&id=06cf333a&scoped=true&"
import script from "./LevelTwoList.vue?vue&type=script&lang=js&"
export * from "./LevelTwoList.vue?vue&type=script&lang=js&"
import style0 from "./LevelTwoList.vue?vue&type=style&index=0&id=06cf333a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf333a",
  null
  
)

export default component.exports